import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { SERVER_URL } from '../initalState';

export const vehicleApi = createApi({
  reducerPath: 'vehicleApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://fastagtracking.com/qiktrack',
        // baseUrl: SERVER_URL+'/qiktrack',
    prepareHeaders: (headers) => {
      headers.set('Content-Type', 'application/json');
      return headers;
    },
  }),
  tagTypes: ['Vehicles'],
  endpoints: (builder) => ({
    getVehicleData: builder.query({
      query: ({ company_id, vehicleNumber }) => ({
        url: '/trackingApi',
        method: 'POST',
        body: {
          company_id,
          tracking_For: 'VAHAN',
          parameters: {
            vehiclenumber: vehicleNumber,
          },
        },
      }),
    }),

       getTrackingData: builder.mutation({
      query: ({ companyId, vehicleNumber }) => ({
        url: '/trackingApi',
        method: 'POST',
        body: {
          company_id: companyId,
          tracking_For: 'FASTAG',
          parameters: { vehiclenumber: vehicleNumber.toUpperCase() },
        },
      }),
      transformResponse: (response) => response.response || [],
      transformErrorResponse: (response) => ({
        status: response.status,
        message: response.data || 'Error fetching tracking data',
      }),
    }),

  }),
});

export const { useGetVehicleDataQuery ,useGetTrackingDataMutation} = vehicleApi;